import React from 'react'
import ChartWrapper from './chartWrapper'
import { ResponsiveContainer } from 'recharts'

const PlaceholderChart = ({ title, message }) => {
	return (
		<ChartWrapper title={title}>
			<ResponsiveContainer width="100%" height={300}>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						height: '100%',
						color: '#999',
						flexDirection: 'column',
					}}>
					<p style={{ textAlign: 'center', maxWidth: 300 }}>
						{message || '*Dados pendentes de implementação.'}
					</p>
				</div>
			</ResponsiveContainer>
		</ChartWrapper>
	)
}

export default PlaceholderChart
